var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<ul uib-pagination ng-disabled=\"$ctrl.disabledIf\" num-pages=\"$ctrl.for.pages\" max-size=\"5\" rotate=\"true\" total-items=\"$ctrl.for.entries\" items-per-page=\"$ctrl.for.options.per_page\" ng-model=\"$ctrl.for.page\" boundary-links=\"true\" ng-change=\"$ctrl.for.changePage()\">\n</ul>";
var id1="public-booking/pagination/pagination.component.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/public-booking/pagination/pagination.component.html
// module id = 1233
// module chunks = 0